import { useState, forwardRef, useImperativeHandle, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import ReactDOM from 'react-dom'
import CloseIcon from '../../assets/icons/cross.png'
import { Container, ModalTemplate, Icon } from './styles'

export const Modal = forwardRef(({
  children,
  focus = true,
  close = null,
  imageControl = false,
  closeOnBackdropClick = true,
  closeOnEscape = true
}, ref) => {
  const [display, setDisplay] = useState(false)
  const { user } = useSelector(state => state)
  useImperativeHandle(ref, () => {
    return {
      show: (action) => show(action),
      hide: () => hide()
    }
  })

  const show = (action) => {
    setDisplay(true)
  }

  const hide = () => {
    setDisplay(false)
  }

  const handleHide = () => {
    if (!close || user.role === 'technical') { hide() } else { close() }
  }

  const handleHideRef = useRef(handleHide)
  useEffect(() => {
    handleHideRef.current = handleHide
  }, [handleHide])

  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === 'Escape' && closeOnEscape) {
        handleHideRef.current()
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [closeOnEscape])

  const onBackdropClick = () => {
    if (closeOnBackdropClick) {
      handleHide()
    }
  }

  const content = (
    <Container focus={focus} onClick={onBackdropClick}>
      <ModalTemplate focus={focus} imageControl={imageControl} onClick={(e) => e.stopPropagation()}>
        {!close && <Icon src={CloseIcon} onClick={handleHide} />}
        {children}
      </ModalTemplate>
    </Container>
  )

  if (display) {
    return ReactDOM.createPortal(content, document.getElementById('modal-root'))
  }

  return null
})

export default Modal
